export const GOOGLE_MAP = "google";
export const A_MAP = "amap";
export const BAIDU_MAP = "baidu";
export const DEFAULT_SELECTED_MAP = A_MAP;

export const PRIVATE_FOLDER_ID = "__privateFolderId__";
